module.exports = "//c.58cdn.com.cn/jinrong/licai/pc/qg/static/img/icon-gh.a1ba0f22.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/FootBar/img/icon-gh.png
// module id = z17i
// module chunks = 1